import { EqlAttributeConfigurationDc } from "@evergis/api";
import { useCallback } from "react";
import { SysAttributesHandlers, useSysAttributes } from "../../../../../../hooks/attributes/useSysAttributes";
import { LayerAttribute } from "../../Layer/LayerAttributeItem";

export function useQuerySysAttributes(
  initialSysAttributes,
  addAttribute: (attributeConfig: EqlAttributeConfigurationDc) => void,
  deleteAttribute,
): [LayerAttribute[], SysAttributesHandlers<LayerAttribute>] {
  const [sysAttributes, { addSysAttributes, deleteSysAttribute, updateSysAttribute, setSysAttributes }] =
    useSysAttributes<LayerAttribute>(initialSysAttributes);

  const addQuerySysAttributes = useCallback(
    attributes => {
      for (const attribute of attributes) {
        addAttribute(attribute);
      }

      addSysAttributes(attributes);
    },
    [addAttribute, addSysAttributes],
  );

  const deleteQuerySysAttribute = useCallback(
    name => {
      deleteAttribute(name);
      deleteSysAttribute(name);
    },
    [deleteAttribute, deleteSysAttribute],
  );

  return [
    sysAttributes,
    {
      updateSysAttribute,
      setSysAttributes,
      addSysAttributes: addQuerySysAttributes,
      deleteSysAttribute: deleteQuerySysAttribute,
    },
  ];
}
